var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section,sindex){return _c(section.alias,{key:sindex,tag:"components",attrs:{"sectionLabel":section.label,"sectionInfoBox":section.info,"memberUID":_vm.memberUID,"memberID":_vm.memberID,"datas":_vm.datas},on:{"checkDate":_vm.checkDate}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }